import { render } from "./OtherMission.vue?vue&type=template&id=90765430&scoped=true"
import script from "./OtherMission.vue?vue&type=script&lang=js"
export * from "./OtherMission.vue?vue&type=script&lang=js"

import "./OtherMission.vue?vue&type=style&index=0&id=90765430&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90765430"]])

export default __exports__